var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
        success: _vm.success,
        danger: _vm.danger,
        primary: _vm.primary,
        tabs: _vm.tabs,
        firstTab: _vm.firstTab,
        lastTab: _vm.lastTab,
        'd-flex justify-content-center align-items-center': _vm.type,
        button: !_vm.margin,
        margin: _vm.margin,
        active: _vm.active
    },on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{class:{button_name: _vm.buttonName && !_vm.primary, primary_black: _vm.primary, 'small-text': _vm.smallText}},[_vm._v(" "+_vm._s(_vm.buttonName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }